































































import { defineComponent, reactive, toRefs, computed, onBeforeMount } from '@vue/composition-api'
import Alerts, { AlertType } from "@/code/alerts";
import { user, HttpPOST } from '@/code/Utils';

import Pagination from "@/components/pagination.vue";

export default defineComponent({
    name: 'Administracion',
    components: {
        Pagination
    },
    setup (props, context) {
        const data = reactive({
            search: '',
            pagination: {
                rowPerPage: 25,
                page: 0,
                count: 1,
                pages: 1
            },
            users: [] as user[]
        }); 

        const tablaUsuarios = computed(() => {
            return (data.users.filter(user => { return user.show })).slice(data.pagination.page * data.pagination.rowPerPage, data.pagination.page * data.pagination.rowPerPage + data.pagination.rowPerPage) as user[];
        });

        const Search = (ev: KeyboardEvent) => {
            const search = data.search.toLowerCase().trim();
            const items = data.users as user[];
            const keys = ["Cod_cliente", "Nombres", "Apellidos", "CUIL", "Email", "Razon_Social"]
                if(search.length > 1){
                    for(var i=0; i < items.length; i++){
                        let bool;
                        const item = items[i];
                        for(var index = 0; index < keys.length; index++){
                            const value = item[keys[index]] ? item[keys[index]].toLowerCase() : "";
                            bool = index == 0 ? value.indexOf(search) != -1 : bool || value.indexOf(search) != -1;
                        }
                        item.show = bool;
                    }
                } else if(search.length < 2){
                for(var i=0; i < items.length; i++){
                    items[i].show = true;
                }
            } 
        }

        const GetUsers = async() => {
            const alert = document.querySelector(".pol-alert");
            if (alert)
                alert.classList.remove('show');
            data.users = [];
            context.root.$store.commit('ChangeLoader', true);

            const response = await HttpPOST(`<?xml version="1.0" encoding="utf-8"?>
                                            <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
                                            <soap12:Body>
                                                <getclientesNroCero xmlns="http://tempuri.org/" />
                                            </soap12:Body>
                                            </soap12:Envelope>`, null) as XMLHttpRequest;

            const Xml = response.responseXML;
            const items = Xml.getElementsByTagName('UserInfoDDJJ');
            for (var i = 0; i < items.length; i++) {
                const current = items[i];
                const COMPANYCODE = current.getElementsByTagName('COMPANYCODE')[0].textContent
                const user = {
                    Cod_cliente: COMPANYCODE ? COMPANYCODE : "0",
                    Nombres: current.getElementsByTagName('NOMBRE')[0].textContent,
                    Apellidos: current.getElementsByTagName('APELLIDO')[0].textContent,
                    CUIL: current.getElementsByTagName('CUIL')[0].textContent,
                    Email: current.getElementsByTagName('EMAIL')[0].textContent,
                    Razon_Social: current.getElementsByTagName('RAZON_SOCIAL')[0].textContent,
                    show: true
                }
                data.users.push(user);
            }

            data.pagination.count = data.users.length;
            data.pagination.pages = Math.ceil(data.users.length / data.pagination.rowPerPage);
            context.root.$store.commit('ChangeLoader', false)
        }

        const clearCodCliente = user => {
            user.Cod_cliente = "0";
        }

        const SetCodCliente = async(user) => {
            const alert = document.querySelector(".pol-alert");
            if (alert)
                alert.classList.remove('show');
            if(!isNaN(user.Cod_cliente)){
                context.root.$store.commit('ChangeLoader', true);
                const xml = `<?xml version="1.0" encoding="utf-8"?>
                            <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
                            <soap12:Body>
                                <ModificarNroClienteDDJJ xmlns="http://tempuri.org/">
                                <email>${user.Email}</email>
                                <cuit>${user.CUIL}</cuit>
                                <nro_cliente>${user.Cod_cliente}</nro_cliente>
                                </ModificarNroClienteDDJJ>
                            </soap12:Body>
                            </soap12:Envelope>`;

                const result = await HttpPOST(xml, null) as XMLHttpRequest;
                
                if(result.statusText == "OK"){
                    const xml_Notification = `<?xml version="1.0" encoding="utf-8"?>
                            <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
                                <soap12:Body>
                                <SendEmail xmlns="http://tempuri.org/">
                                    <To>${user.Email}</To>
                                    <CC></CC>
                                    <Subject>Solicitud de alta.</Subject>
                                    <Title>Alta - Presentación DDJJ de ventas.</Title>
                                    <Content>Se finalizó el alta del usuario en el sistema de DDJJ, ahora puede ingresar y cargar las ventas.</Content>
                                    <Data></Data>
                                </SendEmail>
                                </soap12:Body>
                            </soap12:Envelope>`

                    const result_Notification = await HttpPOST(xml_Notification, window["ROOT_SERVICES"]) as XMLHttpRequest;
                    Alerts.Throw(result_Notification.statusText === "OK" ? "Se actualizó correctamente el código de cliente y se le notificó al cliente." : "Ocurrio un error al intentar notificar al usuario que ha sido completada el alta.", result_Notification.statusText === "OK" ? AlertType.Info : AlertType.Danger, false, 5000)
                    GetUsers();
                } else {
                    Alerts.Throw("Ocurrio un error al intentar actualizar el código, por favor intente nuevamente en unos minutos.", AlertType.Danger, false, 5000)
                    GetUsers();
                }
                context.root.$store.commit('ChangeLoader', false)
            }else {
                Alerts.Throw("Este campo solo permite números, por favor verifique e intente nuevamente.", AlertType.Danger, false, 5000)
            }
        }

        onBeforeMount(async() => {
            const data = context.root.$store.state.session;
            if(!data.user && !data.companyCode){
                const SessionStorage = sessionStorage.getItem("UserLogin")
                if(!SessionStorage) {
                    context.root.$router.push('./').then(() => {
                        Alerts.Throw("La sesión ha expirado, por favor ingrese nuevamente.", AlertType.Danger, false, 6000)
                    })
                } else {
                    GetUsers();
                }
            }
        })

        return {
            ...toRefs(data),
            ...toRefs(context.root.$store.state),
            tablaUsuarios,
            Search,
            GetUsers,
            SetCodCliente,
            clearCodCliente
        }
    }
})
